import { LoadRemote } from '@mindtickle/ui-shell-core/DynamicRemote';

import { DYNAMIC_REMOTES } from '~/config/app.constants';

import { InlineSkeleton } from '@mindtickle/skeleton';
import { withTranslationsInternal } from '~/components/Intl';

const Notifications = () => (
  <LoadRemote
    lazy={false}
    loader={<InlineSkeleton style={{ height: '32px', width: '32px' }} />}
    remote={DYNAMIC_REMOTES.LEARNER_NOTIFICATION}
  />
);
export default withTranslationsInternal({ appName: DYNAMIC_REMOTES.LEARNER_NOTIFICATION.appName })(
  Notifications
);
